import axios from "axios";

export const getStoreEvents = async () => {
  const response = await axios.get(
    `https://app.afrodisemusic.eu/api/v1/storefront/events/`
  );
  return response.data;
};


export const getStoreEventsById = async (id) => {
  const response = await axios.get(
    `https://app.afrodisemusic.eu/api/v1/storefront/events/${id}`
  );
  return response.data;
};
